






module.exports=function StyleSheetPropType(shape){
var createStrictShapeTypeChecker=require('./createStrictShapeTypeChecker');
var StyleSheet=require('../apis/StyleSheet');

var shapePropType=createStrictShapeTypeChecker(shape);
return function(props,propName,componentName,location){
var newProps=props;
if(props[propName]){

newProps={};
newProps[propName]=StyleSheet.flatten(props[propName]);
}
return shapePropType(newProps,propName,componentName,location);
};
};


//////////////////
// WEBPACK FOOTER
// ./~/react-native-web/dist/propTypes/StyleSheetPropType.js
// module id = 64
// module chunks = 0